// extracted by mini-css-extract-plugin
export default {"badge":"InfoBadge_badge__g0QUe","badge__dot":"InfoBadge_badge__dot__16Agf"};